import React, { useState, useEffect, useCallback } from "react";
import { FaPen, FaTrash, FaTimes } from "react-icons/fa";
import "./ShiftList.css";
import Header from "../../layouts/Employee/Header";
import SubHeader from "../../layouts/Admin/SubHeader";
import ShiftListLayout from "../../layouts/Admin/ShiftListLayout";

const ShiftList = () => {
  return (
    <>
      <Header />
      <SubHeader />
      <ShiftListLayout />
    </>
  );
};

export default ShiftList;
